export function setPageMeta(title: string, description: string) {
  document.title = title;
  const meta = document.querySelector('meta[name="description"]');
  if (meta) {
    meta.setAttribute("content", description);
  } else {
    const el = document.createElement("meta");
    el.setAttribute("name", "description");
    el.setAttribute("content", description);
    document.head.appendChild(el);
  }
}